import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { StorageType } from 'mbs-ui-shared';

import { CardGroupComponent, FormGroupComponent, InputComponent, InputPasswordComponent } from 'mbs-ui-kit';

import { I18NextPipe } from 'angular-i18next';

import { ReactiveFormsModule } from '@angular/forms';
import {
  e2eLocators,
  fakeSecretKey
} from '@components/storage-accounts/add-storage-account-wizard/credential-forms/credential-forms.constants';
import { IDriveE2CredentialForm } from '../credential-forms.model';

@UntilDestroy()
@Component({
  selector: 'mbs-credential-form-idrive',
  templateUrl: './credential-form-idrive-e2.component.html',
  styleUrls: ['../credential-forms.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardGroupComponent, FormGroupComponent, I18NextPipe, InputComponent, InputPasswordComponent, ReactiveFormsModule]
})
export class CredentialFormIDriveE2Component implements OnInit {
  @Input() form: IDriveE2CredentialForm;

  public readonly StorageType = StorageType;
  public readonly fakeSecretKey = fakeSecretKey;
  protected readonly e2eLocators = e2eLocators;

  ngOnInit(): void {
    this.accessKey.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.secretKey.patchValue('');
      this.secretKey.updateValueAndValidity();
      this.secretKey.markAsDirty();
      this.secretKey.markAsTouched();
    });
  }

  get accessKey(): FormControl {
    return this.form.get('accessKey') as FormControl;
  }

  get secretKey(): FormControl {
    return this.form.get('secretKey') as FormControl;
  }
}
